/**
 * `{{key}}` 형식의 변수 추출 / 치환 — content 가 single source of truth.
 * 변수 자체 폼을 따로 두지 않고 useMemo 로 항상 content 에서 재계산.
 */

export function extractVariableKeys(content: string): string[] {
  const matches = [...content.matchAll(/\{\{(\w+)\}\}/g)];
  return [...new Set(matches.map((m) => m[1]).filter((v): v is string => v != null))];
}

export function applyVariables(content: string, values: Record<string, string>): string {
  return content.replace(/\{\{(\w+)\}\}/g, (_, key) =>
    Object.hasOwn(values, key) ? (values[key] ?? '') : `{{${key}}}`,
  );
}
